import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { FemaleCondomUpsell } from '@data/tests';
import { Gender } from '@enums/gender';
import { environment } from '@environments/environment';
import { FemaleCondomResponse } from '@models/female-condom-response';
import { StorageService } from '@services/storage.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FemaleCondomService {
  public readonly femaleCondomURL: string = 'female-condom';

  private http = inject(HttpClient);
  private storage = inject(StorageService);

  /**
   * Checks if the Female Condom is already ordered.
   */
  public isFemaleCondomOrdered(): boolean {
    return this.storage.tests.some((test) => test.id === FemaleCondomUpsell.id);
  }

  /**
   * Get the Female Condom upsell content.
   *
   * @returns an Observable of the FemaleCondomResponse
   */
  public getFemaleCondomContent(): Observable<FemaleCondomResponse> {
    return this.http
      .get(`${environment.analyteCareApi}/api/v2/public-files/fc2-female-condom.json`, {
        responseType: 'text',
      })
      .pipe(map((responseText) => JSON.parse(responseText)));
  }

  /**
   * Determines if the user should be redirected to the Female Condom upsell page.
   *
   * It is not offered on product-only orders, such as Men's Intimate Wash on Starfish.
   */
  public shouldRedirectToFemaleCondom(): boolean {
    return (
      this.storage.order.gender === Gender.Female &&
      environment.order.isFemaleCondomUpsellAllowed &&
      (environment.order.triggerFemaleCondomUpsellConsultation || !!this.storage.treatmentType) &&
      !this.storage.orderedTests.some((test) => test.id === FemaleCondomUpsell.id)
    );
  }
}
